var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"operation-item",on:{"click":function($event){$event.stopPropagation();return _vm.meta.click.apply(null, arguments)}}},[_c('div',{staticClass:"operation-item-icon",style:({
    backgroundColor: _vm.meta.enable ? _vm.meta.background_active : _vm.meta.background,
    backgroundImage: `url('${_vm.meta.enable ? _vm.meta.active_icon : _vm.meta.icon}')`
  })}),_c('div',{staticClass:"operation-item-info"},[_vm._v(_vm._s(_vm.meta.info))])])
}
var staticRenderFns = []

export { render, staticRenderFns }